























































































































































































import Vue from "vue";
import vIcon from "@/components/v-components/v-icon.vue";
import { Fetch } from "@/plugins/fetch";
import { mapGetters } from "vuex";
import ReviewScoreButton from "@/components/review/ReviewScoreButton.vue";
import ReviewSummary from "@/components/review/ReviewSummary.vue";
import { sanitizeFeedback } from "@/utils/sanitizers";

export default Vue.extend({
  name: "ReviewForm",
  components: {
    vIcon,
    ReviewScoreButton,
    ReviewSummary
  },
  props: {
    review_metadata: {
      type: Object,
      default() {
        return {};
      }
    },
    score: {
      type: Number,
      default() {
        return 5;
      }
    }
  },
  data: () => {
    return {
      customer: {
        phone: "" as string,
        email: "" as string,
        name: "" as string
      },
      company: {
        name: "" as string,
        email: "" as string,
        picture_url: "" as string
      },
      review: {
        score: 5 as number,
        feedback: "" as string,
        public: false as boolean,
        contact_requested: false as boolean
      },
      review_id: "" as string,
      update_token: "" as string,
      status: "base" as string,
      errors: {
        violating_feedback: false
      } as { [key: string]: boolean }
    };
  },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"])
  },
  methods: {
    preValidateFormData(): boolean {
      if (
        this.review.feedback !== "" &&
        sanitizeFeedback(this.review.feedback) === ""
      ) {
        this.errors.violating_feedback = true;
        return false;
      }
      return true;
    },
    handleFormSubmit(): void {
      if (!this.preValidateFormData()) return;

      this.status = "loading";

      const { review_id, update_token, review } = this;

      Fetch.put(
        `review/${review_id}/?update_token=${update_token}`,
        this.GET_CSRF_INFORMATION.token,
        review
      )
        .then(() => {
          this.status = "done";
        })
        .catch(() => {
          this.status = "fail";
        });
    }
  },
  created() {
    const {
      review_metadata: { customer, company, review_id, update_token },
      score
    } = this.$props;
    this.customer = customer;
    this.company = company;
    this.review.score = score;
    this.review_id = review_id;
    this.update_token = update_token;
  }
});
